import { render, staticRenderFns } from "./UnitItems.vue?vue&type=template&id=17deab75&scoped=true&"
import script from "./UnitItems.vue?vue&type=script&lang=js&"
export * from "./UnitItems.vue?vue&type=script&lang=js&"
import style0 from "./UnitItems.vue?vue&type=style&index=0&id=17deab75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17deab75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTextarea})
